module.exports = __webpack_public_path__ + "img/book-journal-whills.35aa4d7a.svg";